import { Box } from '@chakra-ui/react'
import { FieldMapValue, Form } from '@hb/shared'
import { PropsWithChildren } from 'react'
import { StagePreview } from './StagePreview'

export const FormPreview = ({
  form,
  data,
  corrections,
  readOnly,
  onStageEdit,
  children,
}: PropsWithChildren<{
  form: Form
  data: FieldMapValue | undefined
  corrections: FieldMapValue | undefined
  readOnly?: boolean
  onStageEdit: (stageId: string) => void
}>) => (
  <Box borderLeft="1px solid" borderRight="1px solid" borderColor="gray.200" w="100%">
    {Object.entries(form.stages).map(([stageId, stage], index) => (
      <StagePreview
        index={index}
        form={form}
        id={stageId}
        corrections={corrections}
        readOnly={readOnly}
        onEditClick={() => onStageEdit(stageId)}
        key={stageId}
        stage={stage}
        data={data}
      />
    ))}
    {children}
  </Box>
)
